import { render, staticRenderFns } from "./SignatureList.vue?vue&type=template&id=38416a81&scoped=true&lang=pug"
import script from "./SignatureList.vue?vue&type=script&lang=js"
export * from "./SignatureList.vue?vue&type=script&lang=js"
import style0 from "./SignatureList.vue?vue&type=style&index=0&id=38416a81&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38416a81",
  null
  
)

export default component.exports